import { render, staticRenderFns } from "./AiAssistantWidget.vue?vue&type=template&id=0b9eb4ac&scoped=true"
import script from "./AiAssistantWidget.vue?vue&type=script&lang=js"
export * from "./AiAssistantWidget.vue?vue&type=script&lang=js"
import style0 from "./AiAssistantWidget.vue?vue&type=style&index=0&id=0b9eb4ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9eb4ac",
  null
  
)

export default component.exports